import React from 'react'
import FintechComp from './FintechComp'
import HomeTasComp from './HomeTasComp'
import HowFinayoWork from './HowFinayoWork'
import ProductReview from './ProductReview'
import Services from './Services'
import Slider from './Slider'

const Index = () => {
  return (
    <React.Fragment>
       <Slider />
       <FintechComp />
       <Services />
       <HowFinayoWork />
       <HomeTasComp />
       <ProductReview />
    </React.Fragment>
  )
}

export default Index